$(document)
  .on('click', '.mobile-nav-trigger', () => {
    $('.m-header,.header').toggleClass('show-mobile-nav');
  })
  .on('click', '.toggle-menu', (e) => {
    if (window.screen.width <= 991) {
      $(e.target).parent().toggleClass('open');
    }
  })
  .on('click', (e) => {
    const $con = $('#search-field');
    if (!$con.is(e.target) && $con.has(e.target).length === 0) {
      $('#results').empty();
    }
  })
  .on('click', '.nav-hamburger', () => {
    $('.nav-hamburger').toggleClass('active');
  });

$(() => {
  $('.flexslider').flexslider({
    animation: 'slide',
    directionNav: false,
  });

  $('#search-field').ghostHunter({
    results: '#results',
    onKeyUp: true,
  });
});
